import React, { createContext, useContext, useState } from 'react';

const TenantContext = createContext({});

// Simplified tenant system - LIVE only (validation mode removed)
export const TENANTS = {
  LIVE: 'live'
};

export const TenantProvider = ({ children }) => {
  // Always use LIVE tenant - no more validation mode
  const [tenant] = useState(TENANTS.LIVE);

  // setTenant is a no-op now (kept for backward compatibility)
  const setTenant = () => {
    // Validation mode removed - always use LIVE
  };

  return (
    <TenantContext.Provider value={{ tenant, setTenant, TENANTS }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => useContext(TenantContext);

export default TenantContext;
